/**
 * Slouží k určení, jakým způsobem se má odkaz otevřít
 */
export enum LinkTargetOptions {
    /** V novém okně */
    blank = "_blank",
    /** Ve stávajícím okně */
    self = "_self",
    /** V nadřazaném rámci */
    parent = "_parent",
    /** V celém těle aktuálního okna */
    top = "_top",
}

/**
 * Podporované schémata url adresy
 */
export enum Scheme {
    https = "https://",
    http = "http://",
    mailTo = "mailto:",
    file = "file:///",
}
